<template>
  <span v-if="pillClass" class="badge" :class="pillClass">
    {{ statusText }}
  </span>
  <span v-else>{{ statusText }}</span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { OrderStatus } from "../common/companyOrderTypes";

const props = defineProps<{
  status: OrderStatus;
}>();

const { t } = useI18n();

const PILL_CLASSES: Partial<Record<OrderStatus, string>> = {
  [OrderStatus.WAITING_CONFIRMATION]: "pill-attention",
  [OrderStatus.FAILED]: "pill-attention",
  [OrderStatus.CANCELLED]: "pill-inactive",
};

const pillClass = computed(() => PILL_CLASSES[props.status]);

const statusText = computed(
  () =>
    ({
      [OrderStatus.WAITING_CONFIRMATION]: t(
        "company_orders.status.waiting_confirmation"
      ),
      [OrderStatus.PENDING]: t("company_orders.status.pending"),
      [OrderStatus.PENDING_AGENT]: t("company_orders.status.pending_agent"),
      [OrderStatus.PROCESSING]: t("company_orders.status.processing"),
      [OrderStatus.COMPLETED]: t("company_orders.status.completed"),
      [OrderStatus.FAILED]: t("company_orders.status.failed"),
      [OrderStatus.CANCELLED]: t("company_orders.status.cancelled"),
    })[props.status] ?? props.status
);
</script>
